import { render, staticRenderFns } from "./cashbill-nuera-table.vue?vue&type=template&id=83e4dd30&"
import script from "./cashbill-nuera-table.vue?vue&type=script&lang=js&"
export * from "./cashbill-nuera-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports